// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { SUPABASE_CONFIG, COOKIE_CONFIG, DOMAIN_CONFIG } from "./config";

// Custom cookie storage for cross-domain session sharing
class CrossDomainCookieStorage {
  private cookieName = COOKIE_CONFIG.name;
  private domain = DOMAIN_CONFIG.parentDomain;
  private maxAge = COOKIE_CONFIG.maxAge;

  getItem(key: string): string | null {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const [cookieKey, ...cookieValueParts] = cookie.trim().split("=");
      if (cookieKey === key) {
        const cookieValue = cookieValueParts.join("=");
        try {
          return decodeURIComponent(cookieValue);
        } catch {
          return cookieValue;
        }
      }
    }
    return null;
  }

  setItem(key: string, value: string): void {
    const cookieOptions = [
      `${key}=${encodeURIComponent(value)}`,
      // Only set domain in production
      this.domain ? `domain=${this.domain}` : "",
      `path=/`,
      `max-age=${this.maxAge}`,
      COOKIE_CONFIG.secure ? "secure" : "",
      `samesite=${COOKIE_CONFIG.sameSite}`,
    ]
      .filter(Boolean)
      .join("; ");

    document.cookie = cookieOptions;
  }

  removeItem(key: string): void {
    const cookieOptions = [
      `${key}=`,
      // Only set domain in production
      this.domain ? `domain=${this.domain}` : "",
      `path=/`,
      "max-age=0",
      COOKIE_CONFIG.secure ? "secure" : "",
      `samesite=${COOKIE_CONFIG.sameSite}`,
    ]
      .filter(Boolean)
      .join("; ");

    document.cookie = cookieOptions;
  }
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_CONFIG.url,
  SUPABASE_CONFIG.anonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: new CrossDomainCookieStorage(),
      storageKey: COOKIE_CONFIG.name,
      flowType: "pkce", // Use PKCE flow for better security
    },
  }
);
